/**
 * useDailyContext — Zentraler Hook für Auto-Vorauswahl in Stundenzettel + Stempeluhr.
 *
 * Liefert für einen User + Datum:
 *   - planned_projects: Liste der eingeplanten Projekte (aus Einsatzplanung)
 *   - auto_project_id: nur gesetzt wenn genau 1 unique Projekt geplant ist (Fall A)
 *   - accommodation:   zugewiesene Unterkunft für den Tag (User-Match + Datum im Zeitraum)
 *
 * Verwendung:
 *   const { context, loading } = useDailyContext(userId, date);
 *   if (context?.auto_project_id) setProjectId(context.auto_project_id);
 *   if (context?.accommodation && !overnight) setOvernight(true);
 */
import { useState, useEffect } from "react";
import { authFetch } from "../App";

const API = "/api";

export default function useDailyContext(userId, date) {
  const [context, setContext] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!date) {
      setContext(null);
      return undefined;
    }
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const params = new URLSearchParams({ date });
        if (userId) params.set("user_id", userId);
        const r = await authFetch(`${API}/timesheet/daily-context?${params.toString()}`);
        if (cancelled) return;
        if (!r.ok) {
          setError(`HTTP ${r.status}`);
          setContext(null);
          return;
        }
        const data = await r.json();
        if (cancelled) return;
        setContext(data);
      } catch (e) {
        if (!cancelled) {
          setError(e?.message || "load failed");
          setContext(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [userId, date]);

  return { context, loading, error };
}
